import {createStore, compose, applyMiddleware} from 'redux';
import rootReducer from '../reducers/index';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import actionListeners from './actionListeners';

export default function configureStore() {
	const middleware = [];

	middleware.push(thunk);
	if(IS_LOCALHOST)
	{
		// Logging Middleware
		const logger = createLogger({
			level: 'info',
			collapsed: true
		});
		middleware.push(logger);
	}
	const listeners = actionListeners();
	middleware.push(listeners.middleware);

	const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

	const store = createStore(
		rootReducer,
		composeEnhancer(applyMiddleware(...middleware))
	);
	store.onAction = listeners.onAction;
	return store;
}